<template>
  <div v-if="uploadFile">
    <h1>Upload file</h1>
    <v-card>
      <v-card-text>
        <strong>File&#160;</strong>
        <FileZ :file="uploadFile.file" />
      </v-card-text>
    </v-card>
    <v-btn @click="deleteUploadFile()" color="error">
      <v-icon>delete</v-icon>Delete upload from file
    </v-btn>
    <v-btn @click="download()">Download {{ uploadFile.upload.type }}</v-btn>
    <div class="ajaxForm">
      <v-form ref="formUploadFile" v-model="valid" lazy-validation>
        <v-text-field label="Id" v-model="uploadFile.id" outline />
        <v-combobox
          v-model="description"
          :items="descriptions"
          label="Description"
          no-filter
          @input.native="completeDescription($event.srcElement.value)"
          placeholder="Enter description of document"
          :rules="descriptionRules"
          outline
        />
        <v-btn @click="saveUploadFile"> <v-icon>save</v-icon>Save </v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
import DESCRIPTIONS from "@/graphql/document/Descriptions";
import UPDATE_UPLOADFILE_DESCRIPTION from "@/graphql/document/UpdateUploadFileDescription";
import UPLOAD_FILE_SIGNED_URL from "@/graphql/document/UploadFileSignedUrl";
import FileZ from "@/components/link/FileZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "UploadFile",
  metaInfo() {
    return {
      title: "Upload file",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { FileZ },
  data() {
    return {
      uploadFile: null,
      descriptions: [],
      description: null,
      valid: false,
      descriptionRules: [(v) => !!v || "Description is required"]
    };
  },
  methods: {
    async fetchUploadFile() {
      const response = await nbmlaw.get(
        `/cors/admin/document/uploadFiles/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.uploadFile = response.data;
    },
    async deleteUploadFile() {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(
          `/cors/admin/document/uploadFiles/${this.$route.params.id}`
        );
        this.navigate();
      }
    },
    async completeDescription(value) {
      if (!value) {
        this.descriptions = [];
        return;
      }
      this.description = value;
      const response = await this.$apollo.query({
        query: DESCRIPTIONS,
        variables: { term: value }
      });
      this.descriptions = response.data.descriptions;
    },
    async saveUploadFile() {
      if (this.$refs.formUploadFile.validate()) {
        await this.$apollo.mutate({
          mutation: UPDATE_UPLOADFILE_DESCRIPTION,
          variables: {
            id: Number(this.$route.params.id),
            description: this.description
          }
        });
        // console.log(response.data);
        this.navigate();
      }
    },
    navigate() {
      this.$router.push({
        name: "file",
        params: { id: this.uploadFile.file.id }
      });
    },
    async download() {
      const response = await this.$apollo.query({
        query: UPLOAD_FILE_SIGNED_URL,
        variables: { id: Number(this.$route.params.id) }
      });
      window.open(response.data.uploadFile.upload.signedUrlGet, "_blank");
    },
    update() {
      this.fetchUploadFile();
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.update();
      }
    },
    uploadFile: {
      handler() {
        if (this.uploadFile) {
          this.description = this.uploadFile.uploadDescription.body;
        } else {
          this.description = null;
        }
      }
    }
  }
};
</script>
